import React from 'react';

import { useNavigate } from 'react-router-dom';

import OlcButton from '~/components/General/OlcButton';
import OlcFormModal from '~/components/General/OlcFormModal';
import HomeSearchCIcon from '~/assets/images/create-order/home-search.svg';
import SearchAreaCIcon from '~/assets/images/create-order/search-area.svg';
import OlcTooltip from '~/components/General/OlcTooltip';
import { MESSAGES } from '~/utils/message';

import './styles.scss';

const SEARCH_OPTIONS = [
  {
    icon: HomeSearchCIcon,
    title: 'Radius Around an Address',
    description: 'Enter an address and find contacts within a radius around it.',
    bestFor: 'Reaching nearby homes or businesses that could use your services.',
    mode: 'addresses',
  },
  {
    icon: SearchAreaCIcon,
    title: 'Search an Area',
    description: 'Pick or draw an area, then filter for the contacts you want.',
    bestFor: 'Building a bigger list across a whole market.',
    mode: 'locations',
  },
];

const FindNewContactsModal = ({
  disabledMessage = MESSAGES.MODE.LIVE_MODE_ONLY_FEATURE,
  isDisabled = false,
  open,
  onClose,
  onExited,
}) => {
  const navigate = useNavigate();

  const handleSelect = (mode) => {
    if (isDisabled) return;

    navigate('/orders/create-order', {
      state: { initialOrderOption: 'find_new', initialFindNewOption: mode },
    });
  };

  return (
    <OlcFormModal
      open={open}
      onClose={onClose}
      title="Build your audience"
      subtitle="Pick how you want to create this list."
      className="find-new-contacts-modal"
      dialogProps={{
        onExited,
        transitionDuration: { enter: 160, exit: 100 },
      }}
      footer={
        <>
          <span className="find-new-contacts-note">
            {isDisabled
              ? disabledMessage
              : 'Both options pull verified mailing addresses automatically.'}
          </span>
          <OlcButton type="button" variant="secondary" onClick={onClose}>
            Cancel
          </OlcButton>
        </>
      }
    >
      <div className="find-new-contacts-options">
        {SEARCH_OPTIONS.map((option) => (
          <OlcTooltip
            arrow
            disableInteractive={!isDisabled}
            key={option.title}
            placement="top"
            title={isDisabled ? disabledMessage : ''}
          >
            <span className="find-new-contacts-option-tooltip-target">
              <button
                type="button"
                className={`find-new-contacts-option ${isDisabled ? 'disabled' : ''}`}
                aria-disabled={isDisabled}
                aria-label={`${option.title}: start search`}
                disabled={isDisabled}
                onClick={() => handleSelect(option.mode)}
              >
                <img
                  className="find-new-contacts-option-icon"
                  src={option.icon}
                  alt=""
                  aria-hidden="true"
                />
                <span className="find-new-contacts-option-title">{option.title}</span>
                <span className="find-new-contacts-option-description">{option.description}</span>
                <span className="find-new-contacts-option-best-for">
                  <strong>Best for:</strong> {option.bestFor}
                </span>
              </button>
            </span>
          </OlcTooltip>
        ))}
      </div>
    </OlcFormModal>
  );
};

export default FindNewContactsModal;
